import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export type SkeletonCardListProps = {
    items?: number
    columns?: 1 | 2
    fieldsPerCard?: number
    badge?: boolean
}

export default function SkeletonCardList(props: Readonly<SkeletonCardListProps>) {
    const { items = 7, columns = 1, fieldsPerCard = 3, badge = false } = props

    return (
        <Grid container spacing={2} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Stack
                        direction="row"
                        sx={{ alignItems: 'center', justifyContent: 'space-between' }}
                    >
                        <Skeleton variant="text" width={200} sx={{ fontSize: '1.5rem' }} />
                        <Skeleton variant="circular" width={20} height={20} />
                    </Stack>
                </Paper>
            </Grid>

            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                        {Array.from({ length: items }, (_, index) => (
                            <Grid key={index} size={{ xs: 12, md: 12 / columns }}>
                                <Paper variant="outlined" sx={{ px: 2, py: 1.5 }}>
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        sx={{
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Grid container spacing={3} sx={{ flexGrow: 1 }}>
                                            {Array.from({ length: fieldsPerCard }, (_, cell) => (
                                                <Grid
                                                    key={cell}
                                                    size={{ xs: 12, sm: 12 / fieldsPerCard }}
                                                >
                                                    <Skeleton
                                                        variant="text"
                                                        width="55%"
                                                        sx={{ fontSize: '0.75rem' }}
                                                    />
                                                    <Skeleton variant="text" width="75%" />
                                                </Grid>
                                            ))}
                                        </Grid>
                                        <Stack direction="row" spacing={1.5}>
                                            {badge && (
                                                <Skeleton
                                                    variant="circular"
                                                    width={22}
                                                    height={22}
                                                />
                                            )}
                                            <Skeleton variant="circular" width={22} height={22} />
                                        </Stack>
                                    </Stack>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    )
}
